import React, { useEffect } from 'react';
import { get } from 'lodash';
import OptionsDetailContainer from '@configuratorware/configurator-frontendgui/App/Modules/Creator/Containers/Optiondetail';
import { connect } from 'react-redux';
import OptionDetail from '../../Components/Optiondetail';

const mapStateToProps = ({ ui, configurator, device }) => ({
  show: !ui.visibilityMap.incompatibility && !!ui.visibilityMap.optionDetails,
  title: get(configurator.selectedoptionclassification, 'title', ''),
  optionclassification: configurator.selectedoptionclassification || {},
  details: configurator.optiondetails,
  options: configurator.optionsWithDetails,
  channelSettings: get(configurator.configuration, 'information.channelSettings'),
  languageSettings: get(configurator.configuration, 'information.languageSettings'),
  isTabletDevice: device.screen.isTabletDevice,
});

export default connect(mapStateToProps)((props) => (
  <OptionsDetailContainer
    {...props}
    Component={OptionDetail}
  />
));
